import { DiscordCommand, DiscordCustomEvent, DiscordMountPopupType } from '../../../../../../shared/DiscordActivityTypes.ts';
export class DiscordMountContentFrameDispatcher {
    static sendReadyEvent(instanceId, serverId, userDiscordAccessToken, serverProfile, userPermissions, referrerId, referralTypeId, isInitialLoad) {
        this.sendMessage({
            event: DiscordCustomEvent.Ready,
            command: DiscordCommand.DispatchDiscordEvent,
            data: {
                instanceId: instanceId,
                serverId: serverId,
                userDiscordAccessToken: userDiscordAccessToken,
                serverProfile: serverProfile,
                userPermissions: userPermissions,
                referrerId: referrerId,
                referralTypeId: referralTypeId,
                isInitialLoad: isInitialLoad
            }
        });
    }
    static notifyCommandHasBeenHandled(messageId, event, subscription, command, data) {
        this.sendMessage({
            messageId: messageId,
            event: event,
            subscription: subscription,
            command: command,
            data: data
        });
    }
    static notifyWhenDiscordEventTriggers(subscription, eventData) {
        this.sendMessage({
            event: subscription,
            command: DiscordCommand.DispatchDiscordEvent,
            data: eventData
        });
    }
    static notifyUserAlreadyHasMembershipError(error) {
        this.sendMessage({
            event: DiscordCustomEvent.CreateMountPopup,
            data: {
                popupType: DiscordMountPopupType.UserAlreadyHasMembershipError,
                error: error
            }
        });
    }
    static sendMessage(messageData) {
        var _contentFrame_contentWindow;
        const contentFrame = this.getContentFrame();
        (_contentFrame_contentWindow = contentFrame.contentWindow) === null || _contentFrame_contentWindow === void 0 ? void 0 : _contentFrame_contentWindow.postMessage(messageData, '*');
    }
    static getContentFrame() {
        const contentFrame = document.getElementById('content-frame');
        if (contentFrame == null) {
            throw new Error('Content Frame not found');
        }
        return contentFrame;
    }
}
